<template>
  <Modal v-model="showModal" :mask-closable="false" draggable width="600px">
    <div slot="header">
      {{showLang('auth.user.find')}}
    </div>
    <Form ref="form" :model="form" :label-width="70">
      <FormItem prop="code" :label="showLang('save.search.for')">
        <div style="display: flex">
          <Input ref="code" type="text" maxlength="30" v-model="form.code" :placeholder="showLang('save.user.name')"></Input>
          <Button style="margin-left: 8px" type="primary" @click="getDevicePos">{{showLang('com.op.query')}}</Button>
        </div>
      </FormItem>
      <FormItem :label="showLang('com.cust.organization')">
        <div class="cust-item">{{pos.name}}</div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">{{showLang('com.op.close')}}</Button>
      <Button v-if="canSwitch" type="primary" @click="switchCust">{{showLang('system.jump.custom.app')}}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
export default {
  name: 'ModalWhereDevice',
  components: {
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showModal: this.value,
      form: {
        code: '',
      },
      pos: {},
      canSwitch: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'customerId', 'appType', 'appTypes', 'ops']),
    ...mapGetters('auth', ['showLang']),
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.code = '';
      }
    },
    showModal(val) {
      this.$emit('showChanged', val);
    }
  },
  mounted: function () {
  },
  destroyed: function () {
  },
  methods: {
    switchCust: function () {
      this.$store.dispatch('auth/switchAppCust', { app: this.appType, cust: this.pos.id }).then(res => {
        if (res.code == 0) {
          this.$Message.info(this.showLang('system.switch.success'));
          this.showModal = false;
          setTimeout(() => {
             this.$router.replace(this.appTypes[0].url);
          }, 200);
        }
      });
    },
    getDevicePos: function () {
      if (this.form.code == '') {
        this.$Message.warning(this.showLang('save.query.user'));
        return;
      }
      this.$axios.post(`//${this.domains.trans}/station/auth/WhereUser`, { code: this.form.code }).then(res => {
        if (res.code == 0) {
          this.canSwitch = true;
          this.$set(this, 'pos', res.data);
        } else {
          this.canSwitch = false;
        }
      });
    },
    cancel() {
      this.showModal = false;
    },
  }
}
</script>
<style scoped>
.cust-item {
  border: solid 1px rgba(128, 128, 128, 0.274);
  /* margin: 5px; */
  padding: 2px 10px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-weight: bolder;
  font-size: 20px;
  height: 38px;
}
.item-header {
  height: 20px;
  width: 100%;
  display: flex;
}
.item-name {
  width: 100px;
  flex: auto;
  margin-right: 10px;
  /* border-right: solid 1px gray; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-time {
  width: 170px;
  flex: none;
  /* border-right: solid 1px gray; */
}
.item-type {
  width: 30px;
  flex: none;
  /* border-right: solid 1px gray; */
}
.item-content {
  width: 100%;
  border-top: solid 1px rgba(128, 128, 128, 0.274);
  padding-top: 5px;
  /* white-space: nowrap; */
}
.cust-item:hover {
  border: solid 1px blue;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.form {
  height: calc(100% - 54px);
  overflow: auto;
}
.readonly {
  background: #eee;
}
</style>